module.exports = __webpack_public_path__ + "static/media/saint_chamas_pontflavien.70337006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/saint_chamas_pontflavien.png
// module id = 751
// module chunks = 0